import React, {useState, useEffect, useContext, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyMenuView from '../../views/fullBodyMenuView';
import {temperatureUnitItem} from '../../../App';
import MenuContext from '../../../context/menuContext';
import ConfigContext from '../../../context/configContext';
import DensityUnit from './density-unit';
import ChannelConfig from './channel-config';
import {useTranslation, withTranslation, Trans} from 'react-i18next';
import SetModbus from './set-modbusTN';
import ChannelSelection from './channel';

function FloatByte({onExit}) {
  const {onComponent, setDisableMenu} = useContext(MenuContext);
  const {config, onUpdate} = useContext(ConfigContext);
  const leftPress = useKeyPress('ArrowLeft');
  const onLeft = useCallback(() => {
    onComponent(<SetModbus />);
  }, []);
  const floatByteItems = [
    {
        id:1,
        name: "1-2 3-4",
        children:[
            {id: 11, name:"COMM_FAULT_UPSCALE", requireDoubleRight: true},
            {id: 12, name:"COMM_FAULT_DOWNSCALE", requireDoubleRight: true},
            {id: 13, name:"COMM_FAULT_ZERO", requireDoubleRight: true},
            {id: 14, name:"COMM_FAULT_NAN", requireDoubleRight: true},
            {id: 15, name:"COMM_FAULT_FLOWONLY_ZERO", requireDoubleRight: true},
            {id: 16, name:"COMM_FAULT_NONE", requireDoubleRight: true}
        ]
    },
    {
        id:2,
        name: "3-4 1-2",
        children:[
            {id: 21, name:"COMM_FAULT_UPSCALE", requireDoubleRight: true},
            {id: 22, name:"COMM_FAULT_DOWNSCALE", requireDoubleRight: true},
            {id: 23, name:"COMM_FAULT_ZERO", requireDoubleRight: true},
            {id: 24, name:"COMM_FAULT_NAN", requireDoubleRight: true},
            {id: 25, name:"COMM_FAULT_FLOWONLY_ZERO", requireDoubleRight: true},
            {id: 26, name:"COMM_FAULT_NONE", requireDoubleRight: true}
        ]
    },
    {
        id:3,
        name: "2-1 4-3",
        children:[
            {id: 31, name:"COMM_FAULT_UPSCALE", requireDoubleRight: true},
            {id: 32, name:"COMM_FAULT_DOWNSCALE", requireDoubleRight: true},
            {id: 33, name:"COMM_FAULT_ZERO", requireDoubleRight: true},
            {id: 34, name:"COMM_FAULT_NAN", requireDoubleRight: true},
            {id: 35, name:"COMM_FAULT_FLOWONLY_ZERO", requireDoubleRight: true},
            {id: 36, name:"COMM_FAULT_NONE", requireDoubleRight: true}
        ]
    },
    {
        id:4,
        name: "4-3 2-1",
        children:[
            {id: 41, name:"COMM_FAULT_UPSCALE", requireDoubleRight: true},
            {id: 42, name:"COMM_FAULT_DOWNSCALE", requireDoubleRight: true},
            {id: 43, name:"COMM_FAULT_ZERO", requireDoubleRight: true},
            {id: 44, name:"COMM_FAULT_NAN", requireDoubleRight: true},
            {id: 45, name:"COMM_FAULT_FLOWONLY_ZERO", requireDoubleRight: true},
            {id: 46, name:"COMM_FAULT_NONE", requireDoubleRight: true}
        ]
    }
  ]

  useEffect(() => {
    if (!leftPress) return;

    onComponent(<SetModbus />);
  }, [leftPress]);

  const onRight = selected => {
   // onUpdate('temperature', {...config.temperature, unit: selected.name});
    // setDisableMenu(false);
    setTimeout(() => setDisableMenu(false), 5000);
    onComponent(<ChannelSelection />);
  };
  const {t, i18n} = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  return (
    <FullBodyMenuView
     title={t('channelConfig.a3')}
      menuItems={floatByteItems}
     // onLeftCallback={onLeft}
     // initialSelected={config.temperature.unit}
      onRightCallback={onRight}
    />
  );
}
export default FloatByte;
